import React from 'react';

import {hooks} from '../hooks';
import {AcademyType} from '../types';
  
type Props = {
  index: number;
  academy: AcademyType;
  isLast: boolean;
};

export const AcademyItem: React.FC<Props> = ({index, academy, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <li
      style={{
        borderRadius: 10,
        position: 'relative',
        backgroundColor: 'var(--white-color)',
        display: 'block',
        maxHeight: "100%",
      }}
      onClick={() => navigate(`/detail-academy/${academy.id}`, {state: {academy}})}
    >
      {academy.img && (
        <img
          src={academy.img}
          alt={academy.name}
          style={{objectFit: 'cover', width: '100%', height: 100, borderRadius: 6}}
        />
      )}
      <div style={{display: 'flex', gap: 5, flexDirection: 'column', padding: 14}}>
          <h5 className='number-of-lines-1'>{academy.name}</h5>
          <p className='t12 number-of-lines-2' style={{marginBottom: 10, overflow: 'hidden'}}>{academy.description}</p>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{width: '100%'}}>
      </div>
    </li>
  );
};
